
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VehicleDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Vehicle"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"RecId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"VehicleNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"VehicleTypeRecIdRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"StatusRecIdRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"CategoryRecIdRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"CompanyOwned"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Year"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Make"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Model"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"SerialNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Engine"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Axles"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"TransmissionRecIdRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"RearRecIdRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"BodyRecIdRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"NumDieselTanks"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"TireSizeRecIdRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"WheelSizeRecIdRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"MaxCold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"MaxWarm"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"PlateNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"RegistrationNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"RegistrationState"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"RegistrationExpirationDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"OverWeightPermit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"OverWeightPermitExpirationDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Unladen"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Payload"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"TrycockNet"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"CompanyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Odometer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ELDVehicleId"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":610}};
    doc.loc.source = {"body":"fragment VehicleDetails on Vehicle {\n  RecId\n  VehicleNumber\n  Description\n  VehicleTypeRecIdRef\n  StatusRecIdRef\n  CategoryRecIdRef\n  CompanyOwned\n  Year\n  Make\n  Model\n  SerialNumber\n  Engine\n  Axles\n  TransmissionRecIdRef\n  RearRecIdRef\n  BodyRecIdRef\n  NumDieselTanks\n  TireSizeRecIdRef\n  WheelSizeRecIdRef\n  MaxCold\n  MaxWarm\n  PlateNumber\n  RegistrationNumber\n  RegistrationState\n  RegistrationExpirationDate\n  OverWeightPermit\n  OverWeightPermitExpirationDate\n  Unladen\n  Payload\n  TrycockNet\n  CompanyId\n  Odometer\n  ELDVehicleId\n  # CreatedDateTime\n  # ModifiedDateTime\n  # CreatedBy\n  # ModifiedBy\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["VehicleDetails"] = oneQuery(doc, "VehicleDetails");
        
